import HeadlinePlugin from '@/components/customFields/HeadlinePlugin';
import { type HeadlinePluginData, HeadlineTag } from '@/components/customFields/types';
import type { TextCardProps } from '@/components/textCard/TextCard';
import TextCard from '@/components/textCard/TextCard';
import type { ComponentTextCardsStoryblok } from '@/types/component-types-sb';
import { ColumnWidth } from '@/types/layoutTypes';

import classes from './TextCards.module.scss';

export type TextCardsProps = Pick<ComponentTextCardsStoryblok, 'anchor'> & {
  headline?: HeadlinePluginData;
  cards: TextCardProps[];
  colored?: boolean;
  aspectRatio?: number;
};

const TextCards: React.FC<TextCardsProps> = ({ anchor, aspectRatio, headline, cards, colored }) => {
  return (
    <section id={anchor || undefined}>
      <HeadlinePlugin data={headline} defaultTag={HeadlineTag.H2} defaultStyle={HeadlineTag.H2} />
      <div className={classes.cardGrid}>
        {cards.map((card, index) => (
          <TextCard
            {...card}
            key={index}
            colored={colored}
            aspectRatio={aspectRatio ? aspectRatio : card.aspectRatio ? card.aspectRatio : undefined}
            parentLayout={{
              columnsMobile: ColumnWidth.FULL,
              columnsTablet: ColumnWidth.HALF,
              columnsDesktop: ColumnWidth.ONE_THIRD,
            }}
            replace={card.replace}
          />
        ))}
      </div>
    </section>
  );
};

export default TextCards;
